import * as R from "ramda";
import { getUrn } from "./getUrn.mjs";
const getConcepts = (structure) => R.pipe(
  R.pathOr([], ["data", "conceptSchemes"]),
  R.map(R.propOr([], "concepts")),
  R.unnest,
  R.indexBy(getUrn)
)(structure);
export {
  getConcepts
};
